import React, { useState } from 'react';
import { ConfigProvider, Space } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import qs from 'query-string';
import { fetchUploadToken } from '@/services/rpc/customize';
import OSS from 'ali-oss';
import { v4 as uuid } from 'uuid';
import { ImageUploader, NavBar, Toast, Dialog, Button, Footer } from 'antd-mobile';
import { ImageUploadItem } from 'antd-mobile/es/components/image-uploader';
import './index.scss';

function Upload() {
  const [urlList, setUrlList] = useState(null);
  const back = () => {
    location.href = document.referrer;
  };
  const initClient = async () => {
    const result: any = await fetchUploadToken();
    const client = new OSS({
      region: result.data.data.region,
      accessKeyId: result.data.data.accessKeyId,
      accessKeySecret: result.data.data.accessKeySecret,
      stsToken: result.data.data.securityToken,
      bucket: result.data.data.bucketName
    });
    return client;
  };

  async function mockUpload(file: File) {
    const client = await initClient();
    const customizedImage = await client.put(`pet/${uuid()}.png`, file);
    setUrlList([customizedImage]);
    return {
      url: `https://la-diy-prod.oss-ap-southeast-1.aliyuncs.com/${customizedImage.name}?x-oss-process=image/resize,h_300,m_lfit`
    };
  }

  const maxCount = 3;
  const [fileList, setFileList] = useState<ImageUploadItem[]>([]);

  const startCustomize = () => {
    if (!urlList) {
      Toast.show('Please Upload Your Image Now');
      return;
    }
    console.log(urlList);

    location.href = `${location.origin}/new_customize.html?itemId=${
      qs.parse(location.search).itemId || 'P23271800281'
    }&image=${urlList[0].url}&skuId=${qs.parse(location.search).skuId || 'SP23271800281B'}`;
  };

  return (
    <ConfigProvider locale={enUS}>
      <div className='wrapper'>
        <NavBar onBack={back}></NavBar>
        <div className='header-info'>
          <h2>Upload Your Image</h2>
          <div className='sub-head-info'>Select a photo from your phone</div>
        </div>

        <Space justify='center' block>
          <ImageUploader
            style={{ '--cell-size': '146px', '--gap-vertical': '26px' }}
            preview
            value={fileList}
            onChange={setFileList}
            upload={mockUpload}
            // multiple
            // renderItem={()=><div className='upload'></div>}
            maxCount={1}
            showUpload={fileList.length < maxCount}
            onCountExceed={(exceed) => {
              Toast.show(`最多选择 ${maxCount} 张图片，你多选了 ${exceed} 张`);
            }}
          >
            <div className='adm-image-uploader-cell  upload-container'>
              <img
                src='https://hholove-daily-assets.oss-accelerate.aliyuncs.com/%E4%B8%8A%E4%BC%A0%E7%85%A7%E7%89%87%20%281%29.png'
                alt=''
              />
            </div>
          </ImageUploader>
        </Space>
        <div className='upload-info'>
          <h2>Image Suggestions</h2>
          <ul>
            <li>
              1.File Size: The maximum file size allowed for image uploads is <strong>2MB</strong>.
            </li>
            <li>
              2.File Format: We accept <strong>jpg, png, and webp</strong> image formats.
            </li>
            <li>
              3.Background: <br/>It is recommended that the image background be{' '}
              <strong>white or transparent.</strong>
              <br />
              Avoid using images with overly complex backgrounds.
            </li>
          </ul>
        </div>
        <div className='button-wrapper'>
          <Button
            onClick={startCustomize}
            size='large'
            block
            style={{
              '--background-color': '#ff7600',
              '--border-color': 'transparent',
              '--border-radius': '25px',
              '--text-color':'#ffffff'
            }}
          >
            Customize Now
          </Button>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default Upload;
